import ReactGA from 'react-ga4';

// Safe GA4 event wrapper. GA is only initialized in production builds
// (see src/index.js), so this is a no-op everywhere else and never throws.
export const trackEvent = (category, action, label) => {
    try {
        if (process.env.NODE_ENV === 'production') {
            ReactGA.event({ category, action, label });
        }
    } catch (e) {
        // analytics must never break the user experience
    }
};
